// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__32dTz","inputWrap":"Table_inputWrap__21Ort","col":"Table_col__3kPNZ","bmiTooltip":"Table_bmiTooltip__3bz3k"};